//@flow

import BrowserStorage from './browserStorage'
import { getJWTtoken, refreshJWTtoken } from '../core/api/api.login'

let checkTokenTimeout = null

const MILLISECONDS = 1000

const getToken = () => {
  getJWTtoken().then(data => {
    setTokenCallback(data)
  })
}

export const checkJWTtoken = () => {
  if (!BrowserStorage.get('jwt_access_token_ts')) {
    getToken()
  } else {
    checkRefreshToken()
  }
}

export const removeJWTtoken = () => {
  BrowserStorage.remove('jwt_access_token')
  BrowserStorage.remove('jwt_access_token_ts')
  BrowserStorage.remove('jwt_refresh_token')
}

const checkRefreshToken = () => {
  const access_ts = BrowserStorage.get('jwt_access_token_ts')

  if (!access_ts || Date.now() >= +access_ts) {
    clearTimeout(checkTokenTimeout)
    refreshJWTtoken()
      .then(data => {
        setTokenCallback(data)
      })
      .catch(() => {
        getToken()
      })
  } else {
    if (!checkTokenTimeout) {
      checkTokenTimeout = setTimeout(checkRefreshToken, access_ts - Date.now())
      window.addEventListener('beforeunload', () =>
        clearTimeout(checkTokenTimeout)
      )
    }
  }
}

const parseJwt = token => {
  const base64Url = token.split('.')[1]
  const base64 = base64Url.replace(/-/g, '+').replace(/_/g, '/')
  const jsonPayload = decodeURIComponent(
    window
      .atob(base64)
      .split('')
      .map(c => '%' + ('00' + c.charCodeAt(0).toString(16)).slice(-2))
      .join('')
  )

  return JSON.parse(jsonPayload)
}

const setTokenCallback = data => {
  if (data?.access) {
    const access_token_json = parseJwt(data.access)
    const { exp } = access_token_json

    if (exp) {
      const now = Date.now()
      const access_token_expire = Math.floor((exp * MILLISECONDS - now) / 2)
      BrowserStorage.set('jwt_access_token_ts', now + access_token_expire)
      checkTokenTimeout = setTimeout(checkRefreshToken, access_token_expire)
      window.addEventListener('beforeunload', () =>
        clearTimeout(checkTokenTimeout)
      )
    }
  }
}
